export const cardsConfig = [
  {
    id:       'connectedDrivers',
    bgColor:  '#3b76ef',
    fontColor:'#FFF',
    cardTitle:'Conductores activos',
    svgIcon:  'driver',
    svgColor: '#FFF',
  },
  {
    id:       'totalDrivers',
    bgColor:  '#5e3eef',
    fontColor:'#FFF',
    cardTitle:'Total de conductores',
    svgIcon:  'driver',
    svgColor: '#FFF',
  },
  {
    id:       'connectedClients',
    bgColor:  '#6242f0',
    fontColor:'#FFF',
    cardTitle:'Clientes activos',
    svgIcon:  'account',
    svgColor: '#FFF',
  },
  {
    id:       'totalTravels',
    bgColor:  '#3ecfef',
    fontColor:'#444',
    cardTitle:'Viajes realizados',
    svgIcon:  'location',
    svgColor: '#444',
  },
];
